(function inbentaAnswer() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'inbenta-answer';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  const inbentaApi = GlobalSite.checkDependency('GlobalSite.inbentaApi');
  const searchEngineUi = GlobalSite.checkDependency('GlobalSite.searchEngineUi');

  $(async () => {
    const $button = $('.inbenta-question-rating button');
    const $textarea = $('.inbenta-question-rating textarea');
    const $firstStep = $('.inbenta-question-rating--first-step');
    const $secondStep = $('.inbenta-question-rating--second-step');
    const $finalStep = $('.inbenta-question-rating--final-step');

    const $goBackButton = $('.go-back__button');
    $goBackButton.on('click', () => {
      const redirectionUrl = document.referrer;
      window.location.assign(redirectionUrl);
    });

    const isTracking = inbentaApi.isTracking();

    $secondStep.hide();
    $finalStep.hide();

    $button.on('click', (e) => {
      const $this = $(e.target);

      const source = $this.data('source');
      const trackingType = $this.data('trackingType');
      const trackingValue = $this.data('trackingValue');
      const buttonEvents = {
        Oui: {
          hide: $firstStep,
          show: $finalStep,
        },
        Non: {
          hide: $firstStep,
          show: $secondStep,
        },
        Envoyer: {
          hide: $secondStep,
          show: $finalStep,
        },
      };

      if (!source || !trackingType || !trackingValue || !isTracking) {
        return;
      }

      buttonEvents[$this[0].value].hide.hide();
      buttonEvents[$this[0].value].show.show();

      inbentaApi.sendTrackingEvents(
        {
          type: trackingType,
          data: { code: trackingValue, value: $this.data('value'), comment: $textarea.val() },
        },
        source,
      );
    });

    $textarea.on('keyup', (e) => {
      if (e.target.value.length === 0) {
        $textarea.parent().find('button').prop('disabled', true);
      } else if (e.target.value.length >= 1) {
        $textarea.parent().find('button').prop('disabled', false);
      }
    });

    const $searchInput = $('.inbenta-form-input .search');
    const $submitInput = $('.inbenta-form-submit .submit');
    const $deleteButton = $('.inbenta-form-input .delete-btn');
    const $autocomplete = $('.inbenta-autocomplete');

    const $inbentaHowModal = $('.modal-form-search-content');
    const $modalShowButton = $('button.search-modal');

    const inbentaAuth = await inbentaApi.auth();
    const inbentaHowModal = await inbentaApi.getModalHtml('faq');

    function inbentaHowModalRender() {
      if (inbentaHowModal?.results) {
        $inbentaHowModal.append(inbentaHowModal?.results[0]?.value?.html);
      } else {
        $modalShowButton.hide();
      }
    }

    inbentaHowModalRender();
    inbentaAuth &&
      searchEngineUi(
        [$searchInput, $submitInput, $deleteButton, $autocomplete],
        'faq',
        undefined,
        true,
      );
  });
})();
